import React from "react"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'


function Star(props) {   
    if(props.score < 0.20) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if(props.score < 0.70) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStarHalfAlt} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 1.2) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 1.7) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStarHalfAlt} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 2.2) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 2.7) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStarHalfAlt} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 3.2) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {farStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 3.7) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStarHalfAlt} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 4.2) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {farStar} />
            </span>
        )
    }
    else if (props.score < 4.7) {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStarHalfAlt} />
            </span>
        )

    }
    else {
        return (
            <span className="review-star">
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
                <FontAwesomeIcon icon = {faStar} />
            </span>
        )
    }
    

}

export default Star;



